import { useLocation } from "react-router-dom";
import MainContent from "../../../components/mainContent/MainContent"
import { ListarMinutaDetalleContent } from "./ListarMinutaDetalleContent"

export const ListarMinutaDetalle = () => {
    const location = useLocation();
    const { allowedWrite, dataRegistro, delegacion } = location.state; 
    
    return (
        <MainContent
            component={<ListarMinutaDetalleContent                 
                allowedWrite={allowedWrite}
                dataRegistro={dataRegistro} 
                delegacion={delegacion}
            />}
            titulo={"Visualización de Minuta"}
            noBackground
            tableMaxWidth
        />
    )    
}